import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { UserRole } from './user-role.enum';

export const adminGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.hasRoleValue(UserRole.Admin)) {
    return true;
  }

  return router.createUrlTree(['/access-denied']);
};

export const dealerGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.hasRoleValue(UserRole.Dealer) || authService.hasRoleValue(UserRole.Employee)) {
    return true;
  }

  return router.createUrlTree(['/access-denied']);
};

export const customerGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.hasRoleValue(UserRole.Customer)) {
    return true;
  }

  return router.createUrlTree(['/access-denied']);
};

export const adminOrDealerGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (
    authService.hasRole(UserRole.Admin) ||
    authService.hasRole(UserRole.Dealer) ||
    authService.hasRole(UserRole.Employee)
  ) {
    return true;
  }

  return router.createUrlTree(['/access-denied']);
};
